import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/website/user/interests"
const apiInterestsEndpoint=API_BASE_URL_ENV() + "/website/user/interests"
const apiInterestsIDsEndPoint=API_BASE_URL_ENV() +"/website/user/interests/storage"
 
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
   
    getInterests = (params) => {
        return http.get(apiInterestsEndpoint, { params })
    }
    createInterest=(data)=>{
        return http.post(apiInterestsEndpoint,data)

    }
    deleteInterest=(data)=>{
         return http.delete(apiInterestsEndpoint,{data:{...data}})

    }
    getInterestIDs=()=>{
        return http.get(apiInterestsIDsEndPoint)

    }
}
